import React from 'react';
import { FaLayerGroup, FaBuilding } from 'react-icons/fa';

// Tarjetas KPI de Contratos Mayores (SEACE), estilo 13a: acento azul arriba
// para diferenciarlas del grupo verde de Contratos Menores.
// Devuelve un fragmento con 2 tarjetas que completan la fila de 5 indicadores.
const IndicadoresSeace = ({ data, isLoading }) => {
  const card = {
    background: '#fff',
    border: '1px solid #e2e6ee',
    borderTop: '2px solid #14507d',
    borderRadius: '11px',
    padding: '15px 16px',
    height: '100%',
    boxSizing: 'border-box'
  };

  if (isLoading) {
    return (
      <>
        {[...Array(2)].map((_, i) => (
          <div key={i} style={card}>
            <div style={{ width: '60%', height: 11, borderRadius: 4, background: '#eef1f5', animation: 'pulseCard 1.4s ease-in-out infinite' }} />
            <div style={{ width: '42%', height: 26, borderRadius: 5, background: '#eef1f5', marginTop: 13, animation: 'pulseCard 1.4s ease-in-out infinite' }} />
            <div style={{ width: '72%', height: 10, borderRadius: 4, background: '#eef1f5', marginTop: 11, animation: 'pulseCard 1.4s ease-in-out infinite' }} />
          </div>
        ))}
      </>
    );
  }

  const indicadores = [
    {
      label: 'Contratos Mayores · Nuevas Convocatorias',
      value: data?.totalRegistros ?? 0,
      icon: FaLayerGroup,
      sub: 'Registrados en el SEACE'
    },
    {
      label: 'Contratos Mayores · Entidades',
      value: data?.entidadesUnicas ?? 0,
      icon: FaBuilding,
      sub: 'Entidades únicas hoy en el SEACE'
    }
  ];

  return (
    <>
      {indicadores.map((ind, i) => {
        const Icon = ind.icon;
        // Continúa el escalonado de las 3 tarjetas de Contratos Menores
        const delay = `${((i + 3) * 0.04).toFixed(2)}s`;
        return (
          // El wrapper lleva la entrada (dvUp) para que no pise el translate del hover
          <div key={ind.label} style={{ animation: `dvUp .32s ease ${delay} both` }}>
            <div className="dash-kpi" style={card}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                <span style={{ flex: 1, minWidth: 0, minHeight: 34, fontSize: '12.5px', fontWeight: 600, color: '#5b6779', lineHeight: 1.35 }}>
                  {ind.label}
                </span>
                <span style={{
                  width: 28,
                  height: 28,
                  borderRadius: 8,
                  background: '#eff6fb',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <Icon size={14} color="#7ea3c4" />
                </span>
              </div>
              <div style={{
                fontSize: '34px',
                fontWeight: 600,
                color: '#0f172a',
                letterSpacing: '-0.03em',
                lineHeight: 1,
                marginTop: '6px',
                animation: `dvFade .55s ease ${delay} both`
              }}>
                {Number(ind.value).toLocaleString('es-PE')}
              </div>
              <div style={{ fontSize: '12px', color: '#5b6779', marginTop: '9px' }}>{ind.sub}</div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default IndicadoresSeace;
